module.exports = __webpack_public_path__ + "static/img/img.7b37326a.png";